import type { Language } from '@offer-catalog/services/i18n'
import type { ReactNode } from 'react'
import type { Family } from '@/types/treeViewTypes'
import { VpIcon } from '@vtmn-play/react/headless'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import './family-card.scss'

export interface FamilyCardProps {
  family: Family
  selectCard: () => void
  isSelected: boolean
  labelContent?: ReactNode
}

export function FamilyCard({
  family,
  selectCard,
  isSelected,
  labelContent,
}: Readonly<FamilyCardProps>) {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language.split('-')[0] as Language

  return (
    <button
      type="button"
      className={clsx('family-card', { selected: isSelected })}
      data-testid="family-card"
      onClick={selectCard}
    >
      <div className="img-container" data-testid={`family-picture_${family.id}`}>
        <VpIcon name="image" />
      </div>
      <div className="family-id" data-testid={`family-id_${family.id}`}>
        {family.id}
      </div>
      <div className="family-label" data-testid={`family-label_${family.id}`}>
        {labelContent ?? family.labels[currentLanguage]}
      </div>
    </button>
  )
}
